import React from 'react';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ComposedChart } from 'recharts';
import { DailyReport } from '../../services/dailyReportService';

interface EnergyCUFChartProps {
  data: DailyReport[];
}

export const EnergyCUFChart: React.FC<EnergyCUFChartProps> = ({ data }) => {
  const chartData = data.map(report => ({
    date: new Date(report.date).toLocaleDateString(),
    energy: report.total_energy_kwh,
    cuf: report.cuf
  }));

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h3 className="text-lg font-semibold mb-4">Daily Energy & CUF Trends</h3>
      <ResponsiveContainer width="100%" height={300}>
        <ComposedChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis yAxisId="left" />
          <YAxis yAxisId="right" orientation="right" />
          <Tooltip />
          <Bar yAxisId="left" dataKey="energy" fill="#3B82F6" name="Energy (kWh)" />
          <Line yAxisId="right" type="monotone" dataKey="cuf" stroke="#F59E0B" strokeWidth={2} name="CUF (%)" />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};